import {jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";import styled from '@emotion/styled'
import graphql from 'babel-plugin-relay/macro'
import {useState} from 'react'
import {useFragment} from 'react-relay'

import IconLabel from '../../../../components/IconLabel'
import LinkButton from '../../../../components/LinkButton'
import {PALETTE} from '../../../../styles/paletteV3'
import ArchiveOrganizationForm from './ArchiveOrganizationForm'





const Hint = styled('div')({
  color: PALETTE.SLATE_600,
  fontSize: 13,
  marginTop: 8
})

const ArchiveOrganization = (props) => {
  const {organization: organizationRef} = props
  const organization = useFragment(
    graphql`
      fragment ArchiveOrganization_organization on Organization {
        ...ArchiveOrganizationForm_organization
      }
    `,
    organizationRef
  )
  const [showConfirmationField, setShowConfirmationField] = useState(false)
  const handleClick = () => {
    setShowConfirmationField(true)
  }
  const handleFormBlur = () => {
    setShowConfirmationField(false)
  }
  return (
    _jsx('div', { children: 
      !showConfirmationField ? (
        _jsxs('div', { children: [
          _jsx(LinkButton, {
            'aria-label': "Click to permanently delete this organization."     ,
            palette: "red",
            onClick: handleClick,
 children: 
            _jsx(IconLabel, { icon: "remove_circle", label: "Delete organization" ,} )
          })
          , _jsxs(Hint, { children: [
            _jsx('b', { children: "Note"}), ": " , 'This can’t be undone.'
          ]})
        ]})
      ) : (
        _jsx(ArchiveOrganizationForm, { handleFormBlur: handleFormBlur, organization: organization,} )
      )
    })
  )
}

export default ArchiveOrganization
